<script lang="ts">
  import SettingsUserIndex from "@modern/components/retailer/settings/User/Index.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";

  const load = async () => {
    return HttpPromise({
      method: "GET",
      url: "/api/retailer/employees",
    });
  };

</script>

{#await load()}
  <Spinner />
{:then users}
  <SettingsUserIndex {users} />
{:catch error}
  {#if error.error}
    <div>Error: {error.error}</div>
  {/if}
{/await}
